import React from 'react';
import { TagIcon } from '@heroicons/react/24/outline';

const Brands: React.FC = () => {
  return (
    <div className="section-card">
      <h1 className="section-title">Brands</h1>
      <p className="section-description">
        Manage your brands and their associated information in the dashboard.
      </p>

      <div className="mt-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Features
        </h2>
        <div className="space-y-4">
          <div className="feature-item">
            <TagIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Brand Management</h3>
              <p className="feature-description">
                Create, edit, and manage brand information including:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Brand name (required)</li>
                <li>Brand website URL (required, must be a valid URL)</li>
                <li>Brand logo (required, must be 210x100 pixels)</li>
              </ul>
            </div>
          </div>

          <div className="feature-item">
            <TagIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Brand List</h3>
              <p className="feature-description">
                View and manage your brands in a table format with the following columns:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Logo (displayed as a circular image)</li>
                <li>Brand name (searchable)</li>
                <li>Website URL (searchable)</li>
                <li>Creation date (sortable, hidden by default)</li>
                <li>Last update date (sortable, hidden by default)</li>
              </ul>
            </div>
          </div>

          <div className="feature-item">
            <TagIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Actions</h3>
              <p className="feature-description">
                Available actions for managing brands:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Edit brand information</li>
                <li>Delete individual brands</li>
                <li>Bulk delete multiple brands</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Best Practices
        </h2>
        <div className="bg-blue-50 p-4 rounded-lg">
          <ul className="list-disc list-inside space-y-2 text-blue-800">
            <li>Ensure brand logos are exactly 210x100 pixels for optimal display</li>
            <li>Use valid website URLs with the https:// prefix</li>
            <li>Keep brand information up to date</li>
            <li>Use high-quality brand assets</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Brands; 